<template>
  <BCard class="p-0">
    <div class="flex flex-row items-center justify-between">
      <div class="flex">
        <BButton
          variant="primary"
          size="sm"
          class="mr-1 rounded-lg p-0"
          @click="$router.go(-1)"
        >
          <feather-icon
            size="2x"
            icon="ChevronLeftIcon"
          />
        </BButton>
        <div class="text-black font-semibold m-0 text-2xl">
          Detail Kartu
        </div>
      </div>
    </div>
    <BOverlay
      variant="transparent"
      :show="!cards.id"
    >
      <div class="mt-[20px] wrapper_card">
        <div>
          <div class="flex justify-center">
            <MasterCardDetail :data="cards" />
          </div>
          <div class="text-[14px] font-semibold flex gap-[5px]">
            <button
              v-if="role !== 'TALENT GLOBAL'"
              :disabled="['inactive', 'freeze', 'cancel'].includes(cards.status)"
              :class="
                cards.status !== 'active' || cards.level === 'gold'
                  ? 'text-[#C2C2C2] cursor-auto'
                  : 'text-[#333333] cursor-pointer border-[1px] border-[#E2E2E2] hover:bg-gray-100'
              "
              class="flex items-center justify-center grow outline-none gap-[4px] py-[5px] px-[10px] rounded-[6px] w-full"
              @click="cards.level !== 'gold' && handleTopup('topup')"
            >
              <span class="k-send-square" />
              <div class="text-nowrap">
                Top up
              </div>
            </button>
            <button
              :disabled="['inactive', 'freeze', 'cancel'].includes(cards.status)"
              :class="
                cards.status === 'active'
                  ? 'text-[#333333] cursor-pointer border-[1px] border-[#E2E2E2] hover:bg-gray-100'
                  : 'text-[#C2C2C2] cursor-auto'
              "
              class="flex items-center justify-center grow outline-none gap-[4px] py-[5px] px-[10px] rounded-[6px] w-full"
              @click="handleTransfer"
            >
              <span class="k-convert-card" />
              <div class="text-nowrap">
                Transfer Saldo
              </div>
            </button>

            <button
              id="action"
              ref="action"
              style="border: 1px solid #E2E2E2 !important"
              class="flex outline-none items-center hover:bg-gray-100 h-[32px] justify-center cursor-pointer gap-[4px] py-[5px] px-[10px] border-[1px] border-[#E2E2E2] rounded-[6px] w-full"
            >
              <div class="font-semibold text-[#333333] sm:inline">
                <span class="d-none d-sm-block">Lainnya</span>
              </div>
              <img
                class="h-[13px] md:h-[16px]"
                height="12"
                src="https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/arrow-down-1.svg"
                alt="send-square"
              >
            </button>

            <BPopover
              id="action"
              target="action"
              triggers="click"
              placement="bottom"
              offset="10"
            >
              <div
                v-for="act in listAction"
                :key="act.id"
              >
                <button
                  :disabled="act.disabled"
                  :class=" act.disabled ? 'text-[#C2C2C2]' : 'text-[#333333]'"
                  class=" cursor-pointer items-center flex gap-2"
                  @click="
                    act.onClick(cards.level)
                    $root.$emit('bv::hide::popover', 'action')
                  "
                >
                  <span :class="act.icon" />
                  <span v-if="act.id === 3">{{ act.label === cards.status ? 'Nonaktifkan' : 'Aktifkan' }}</span>
                  <span v-if="act.id !== 3">{{ act.label }}</span>
                </button>
                <div class="mt-[5px] mb-[5px]" />
              </div>
            </BPopover>
          </div>
          <div
            class="flex bg-[#FEF2CD] mt-[12px] text-[#333333] items-center px-[8px] py-[10px] rounded-[8px]  justify-between"
          >
            <div class="text-[12px]">
              Saldo Komcards
            </div>
            <div class="text-[16px] font-semibold">
              {{ IDR(cards.balance, 2, 2) }}
            </div>
          </div>
        </div>
        <div class="mt-[20px] md:mt-0">
          <div>
            <div class="flex justify-between items-center">
              <div
                class="text-[#333333] font-semibold text-[14px] md:text-[16px]"
              >
                Informasi Kartu
              </div>
              <BButton
                size="sm"
                :class="showReveal && 'active-reveal'"
                class="text-[14px] md:text-[16px]"
                :variant="
                  showReveal || loading.file || cards.status !== 'active'
                    ? 'secondary'
                    : 'primary'
                "
                :disabled="
                  showReveal || loading.file || cards.status !== 'active'
                    ? true
                    : false
                "
                @click="checkKyc('reveal')"
              >
                <BSpinner
                  v-if="loading.reveal || loading.file"
                  variant="light"
                  small
                />
                <span
                  class="sm:ml-1 ml-[2px]"
                >Cek Data Kartu
                  <span
                    v-if="showReveal"
                    class="bg-[#F95031] p-[3px] rounded-full text-white"
                  >{{ timerCount }}</span></span>
                <BIcon
                  class="ml-[5px]"
                  icon="eye"
                />
              </BButton>
            </div>
            <hr class="border-[1px] my-[10px] border-[#E2E2E2] border-dashed">
            <div class="flex flex-column gap-[16px] text-[14px] md:text-[16px]">
              <div class="flex justify-between items-center">
                <div class="text-[#626262]">
                  Nomor kartu
                </div>
                <div class="flex gap-[8px] items-start">
                  <div class="text-[#333333]">
                    {{
                      !showReveal
                        ? `xxxx xxxx xxxx ${cards.card_number}`
                        : reveal.cardNumber
                    }}
                  </div>
                  <button
                    class="h-[5px] outline-none"
                    :class="showReveal && 'cursor-pointer'"
                    :disabled="!showReveal"
                    @click="handleCopyCardNumber"
                  >
                    <div
                      :class="
                        showReveal &&
                          'border-[1px] border-[#F95031] p-[2px] rounded-md'
                      "
                    >
                      <img
                        class="h-[16px]"
                        :src="
                          !showReveal
                            ? 'https://storage.googleapis.com/komerce/assets/copy.svg'
                            : 'https://storage.googleapis.com/komerce/assets/komerce-icon/Orange/copy.svg'
                        "
                        alt="copy"
                      >
                    </div>
                  </button>
                </div>
              </div>
              <div class="flex justify-between items-center">
                <div class="text-[#626262]">
                  CVV (3-digit kode keamanan)
                </div>
                <div class="text-[#333333]">
                  {{ !showReveal ? cards.cvv : reveal.cvv }}
                </div>
              </div>
              <div class="flex justify-between items-center">
                <div class="text-[#626262]">
                  Berlaku sampai (mm/yy)
                </div>
                <div class="text-[#333333]">
                  {{ !showReveal ? cards.exp_date : reveal.expDate }}
                </div>
              </div>
            </div>
          </div>
          <div class="mt-[24px]">
            <div
              class="text-[#333333] font-semibold text-[14px] md:text-[16px]"
            >
              Detail Saldo
            </div>
            <hr class="border-[1px] my-[10px] border-[#E2E2E2] border-dashed">
            <div class="flex flex-column gap-[16px]">
              <div class="flex justify-between items-center">
                <div class="text-[#626262]">
                  Voucher iklan
                </div>
                <div class="text-[#333333]">
                  {{ IDR(cards.voucher_balance, 2, 2) }}
                </div>
              </div>
              <div class="flex justify-between items-center">
                <div class="flex gap-[7px] items-center">
                  <div class="text-[#626262]">
                    Saldo pending
                  </div>
                  <div id="tooltip-button-variant">
                    <img
                      class="h-[16px]"
                      src="https://storage.googleapis.com/komerce/assets/svg/info-circle.svg"
                      alt="info"
                    >
                    <b-tooltip
                      target="tooltip-button-variant"
                      variant="light"
                      class="bg-red-100"
                    >Saldo ini belum dapat ditarik, namun bisa digunakan untuk
                      transaksi. Pihak penyedia layanan segera memprosesnya
                      kembali ke kartu debit kamu</b-tooltip>
                  </div>
                </div>
                <div class="text-[#333333]">
                  {{ IDR(cards.hold_balance, 2, 2) }}
                </div>
              </div>
              <div class="flex justify-between items-center">
                <div class="text-[#333333]">
                  <div class="text-[#626262]">
                    Spending harian
                  </div>
                  <div class="flex flex-row items-center gap-2">
                    <div class="text-[12px] text-[#828282]">
                      max. {{ IDR(cards.daily_spending_limit, 2, 2) }}
                    </div>
                    <!-- <BButton
                      v-if="role !== 'TALENT GLOBAL' && cards.level === 'platinum'"
                      :variant="cards.status !== 'active' ? 'outline-secondary' : 'outline-primary'"
                      size="sm"
                      class="!flex !items-center gap-1"
                      :disabled="cards.status !== 'active'"
                      @click="handleDailyLimit"
                    >
                      Up Daily Limit
                    </BButton> -->
                  </div>
                </div>
                <div class="text-[#333333]">
                  {{ IDR(cards.daily_spending, 2, 2) }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </BOverlay>
    <BRow
      v-if="role !== 'TALENT GLOBAL'"
      class="flex flex-col justify-center gap-3 p-1"
    >
      <div class="text-black font-semibold m-0 text-2xl">
        Akses kartu
      </div>
      <BRow v-if="!isEmpty(cards.team_members)">
        <BCol
          v-for="(data, idx) in cards.team_members.slice(0, 8)"
          :key="idx"
          lg="3"
          sm="6"
          md="3"
          class="flex items-center gap-2 mt-1"
        >
          <BAvatar
            v-b-tooltip.hover
            :title="data"
            :style="{ background: getAvatarData(data).background }"
          >
            {{ getAvatarData(data).acronym }}
          </BAvatar>
          <span class="capitalize">{{ data }}</span>
        </BCol>
      </BRow>
      <BCollapse id="collapse-remaining">
        <BRow>
          <BCol
            v-for="(data, idx) in cards.team_members.slice(8)"
            :key="idx"
            lg="3"
            sm="6"
            md="3"
            class="flex items-center gap-2 mb-1"
          >
            <BAvatar
              v-b-tooltip.hover
              :title="data"
              :style="{ background: getAvatarData(data).background }"
            >
              {{ getAvatarData(data).acronym }}
            </BAvatar>
            <span class="capitalize">{{ data }}</span>
          </BCol>
        </BRow>
      </BCollapse>
      <div
        v-if="cards.team_members.length > 8"
        v-b-toggle.collapse-remaining
        class="text-center text-blue-500 cursor-pointer mt-2"
        @click="isCollapsed = !isCollapsed"
      >
        {{ isCollapsed ? 'Lihat lebih sedikit' : 'Lihat selengkapnya' }}
      </div>

      <div
        v-if="isEmpty(cards.team_members)"
        class="flex flex-col items-center gap-2 text-black"
      >
        <div class="font-medium">
          Ayo, tambahkan anggota team!
        </div>
        <div>Ayo, undang team kamu untuk mulai mengelola akun!</div>
        <BButton
          variant="primary"
          size="sm"
          class="!flex !items-center gap-1"
          @click="$router.push('/talent')"
        >
          <feather-icon icon="PlusIcon" />
          <div>Tambah Team</div>
        </BButton>
      </div>
    </BRow>
    <hr class="border-[1px] my-[10px] border-[#E2E2E2] border-dashed">
    <BRow class="pl-[15px] pr-[15px] items-center justify-between mt-1">
      <div class="text-black font-semibold m-0 text-2xl">
        Mutasi
      </div>
      <div class="flex items-center flex-row">
        <div class="ml-1">
          <BButton
            id="filter"
            size="sm"
            variant="primary"
          >
            <img
              src="https://storage.googleapis.com/komerce/assets/komerce-icon/Putih/filter-search.svg"
              alt="Komerce"
              width="20"
            >
          </BButton>
          <BPopover
            target="filter"
            triggers="click"
            placement="bottomleft"
          >
            <label>Tanggal</label>
            <BRow>
              <BCol md="6">
                <FlatPickr
                  v-model="startDate"
                  class="form-control"
                  placeholder="Mulai Dari"
                  :config="{
                    mode: 'single',
                    altInput: true,
                    altFormat: 'j/n/Y',
                    dateFormat: 'Y-m-d',
                  }"
                  @input="setStartDate"
                />
              </BCol>
              <BCol md="6">
                <FlatPickr
                  v-model="endDate"
                  class="form-control"
                  placeholder="Sampai Dengan"
                  :config="{
                    mode: 'single',
                    altInput: true,
                    altFormat: 'j/n/Y',
                    dateFormat: 'Y-m-d',
                    minDate: startDate,
                  }"
                  @input="setEndDate"
                />
              </BCol>
            </BRow>
            <label class="mt-1">Jenis Transaksi</label>
            <VSelect
              v-model="transactionType"
              :options="optionsTransactionType"
              :reduce="option => option.value"
              label="name"
              @input="setTransactionType"
            >
              <span
                slot="no-options"
                @click="$refs.select.open = false"
              />
            </VSelect>

            <BRow class="mx-auto mt-2">
              <BButton
                variant="outline-primary"
                class="mr-1"
                @click.prevent="resetFilter()"
              >
                Reset
              </BButton>
              <BButton
                variant="primary"
                @click.prevent="getMutation($route.params.id)"
              >
                Terapkan
              </BButton>
            </BRow>
          </BPopover>
        </div>
      </div>
    </BRow>
    <Mutation
      :scroll="'scroll'"
      :loading="loading.mutation"
      :items="listMutation"
      :fields="fields"
      :status-class="statusClass"
      :nominal-class="nominalClass"
    />

    <ModalDailyLimit :cards="cards" />
    <ModalDailyLimitError
      :error-title="dailyLimitErrorTitle"
      :error-message="dailyLimitErrorMessage"
    />

    <ModalVerificationKyc
      :id-modal="idModal"
      :title="'Kamu perlu verifikasi KTP'"
      :desc="
        'Yuk ajukan verifikasi KTP dan Selfie dengan KTP sekarang juga untuk memvalidasi keaslian akunmu dan melihat data kartumu!'
      "
      :source="'pending'"
      :submit="routeVerification"
    />
    <ModalChangeCardName
      ref="modalChangeCardName"
      :card="cards"
      @update-input="updateCardName"
    />

    <ModalChangeLabel
      ref="modalChangeLabel"
      :card="cards"
      @update-input="updateLabel"
    />

    <ModalWithdrawal
      ref="modalWithdrawal"
      :balance="balanceDetail"
      @update-nominal-withdrawal="updateNominalWithdrawal"
    />

    <ModalTransfer
      :id="parseInt(cardId, 10)"
      ref="modalTransfer"
      :info-balance="balanceDetail"
      @update-payload-transfer="updatePayloadTransfer"
    />

    <ModalTopup
      ref="modalTopup"
      :card-data="cards"
      :balance="balanceData"
      @update-nominal-topup="updateNominalTopup"
    />

    <ModalPIN
      id="modal-verify-pin"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      title="Verifikasi PIN"
      description="Mohon verifikasi identitas kamu dengan masukan PIN"
      label-confirm-button="Konfirmasi"
      label-cancel-button="Kembali"
      @on-confirm-button="onSubmit"
      @on-cancel-button="onClose"
    />

    <ModalMaxChancePIN />
  </BCard>
</template>

<script>
import { IDR } from '@/libs/currency'
import { komshipAxiosIns, newAxiosIns } from '@/libs/axios'
import moment from 'moment'
import FlatPickr from 'vue-flatpickr-component'
import VSelect from 'vue-select'
import secureLs from '@/libs/secureLs'
import getAcronym from '@/libs/acronym'
import isEmpty from 'lodash/isEmpty'
import ModalPIN from '@/views/components/modal/ModalPIN.vue'
import ModalMaxChancePIN from '@/views/components/modal/ModalMaxChancePIN.vue'
import { columnConfigDetail, optionsTransactionType } from './config'
import {
  Mutation,
  ModalTopup,
  ModalVerificationKyc,
  MasterCardDetail,
  ModalTransfer,
  ModalChangeCardName,
  ModalDailyLimit,
  ModalDailyLimitError,
  ModalWithdrawal,
  ModalChangeLabel,
} from './components'
import '@/@core/scss/vue/libs/vue-flatpicker.scss'

export default {
  components: {
    Mutation,
    ModalPIN,
    VSelect,
    FlatPickr,
    ModalTopup,
    ModalVerificationKyc,
    MasterCardDetail,
    ModalTransfer,
    ModalChangeCardName,
    ModalDailyLimit,
    ModalDailyLimitError,
    ModalWithdrawal,
    ModalMaxChancePIN,
    ModalChangeLabel,
  },
  data() {
    return {
      IDR,
      isEmpty,
      role: secureLs.getItem('userData').role_name.toUpperCase(),
      stateForOpenPIN: '',
      loading: {
        mutation: false,
        status: false,
        reveal: false,
        card: false,
        file: false,
        informationBalance: false,
        dailyLimit: false,
      },
      listMutation: [],
      cards: {
        labels: null,
        name: null,
        card_network: null,
        id: null,
        balance: null,
        card_number: null,
        exp_date: null,
        cvv: null,
        status: null,
        amount: null,
        hold_balance: null,
        voucher_balance: null,
        daily_spending: null,
        daily_spending_limit: null,
        team_members: [],
        level: null,
      },
      reveal: {
        cardNumber: null,
        cvv: null,
        expDate: null,
      },
      showReveal: false,
      cardId: this.$route.params.id,
      startDate: moment()
        .startOf('month')
        .format('YYYY-MM-DD'),
      endDate: moment().format('YYYY-MM-DD'),
      transactionType: '',
      limit: 10,
      offset: 0,
      timerCount: 60,
      fields: columnConfigDetail,
      optionsTransactionType,
      idPartner: this.$store.state.auth.userData.id,
      lastData: false,
      label: null,
      labelOriginal: null,
      modalType: null,
      balanceDetail: {},
      card_name: null,
      card_label: null,
      nominal_withdrawal: null,
      transferAmount: null,
      cardTransferId: null,
      topupAmount: null,
      idModal: 'modal-requested-kyc',
      isCollapsed: false,
      isLoadingVerifyPin: false,
      dailyLimitErrorTitle: '',
      dailyLimitErrorMessage: '',
      balanceData: null,
    }
  },
  computed: {
    action() {
      return [
        {
          id: 1,
          label: 'Ubah Nama',
          icon: 'k-card-edit',
          disabled: ['freeze', 'cancel', 'inactive'].includes(this.cards.status),
          onClick: level => {
            if (level === 'bronze') return

            this.stateForOpenPIN = 'change-card-name'
            this.checkVerifyPIN('change-card-name')
            // this.$bvModal.show('modal-change-card-name')
          },
        },
        {
          id: 2,
          label: 'Tarik Saldo',
          icon: 'k-receive-square',
          disabled: ['freeze', 'cancel', 'inactive'].includes(this.cards.status),
          onClick: () => {
            this.stateForOpenPIN = 'withdrawal'
            this.checkKyc('withdrawal')
            this.checkBalance()
          },
        },
        {
          id: 3,
          label: 'active',
          icon: 'k-card-remove',
          // enabled jika status nya inactive, selain itu disabeld
          disabled: ['freeze', 'cancel'].includes(this.cards.status),
          onClick: () => {
            this.stateForOpenPIN = 'active-inactive'
            this.checkVerifyPIN('active-inactive')
          },
        },
        {
          id: 4,
          label: 'Ubah Label',
          icon: 'k-note-text',
          disabled: ['freeze', 'cancel', 'inactive'].includes(this.cards.status),
          onClick: () => {
            this.stateForOpenPIN = 'change-label'
            this.checkVerifyPIN('change-label')
          },
        },
      ]
    },
    listAction() {
      return this.role === 'TALENT GLOBAL'
        ? this.action.filter(act => [1, 2, 4].includes(act.id))
        : this.action
    },
    setTransactionType() {
      return type => {
        this.transactionType = type
      }
    },
    setStartDate() {
      return date => {
        this.startDate = date
      }
    },
    setEndDate() {
      return date => {
        this.endDate = date
      }
    },
    statusClass() {
      return status => {
        if (status === 'success') {
          return 'text-[#34A770]'
        }
        if (status === 'failed') {
          return 'text-[#E31A1A]'
        }
        if (status === 'pending') {
          return 'text-[#828282]'
        }
        return ''
      }
    },
    nominalClass() {
      return type => {
        if (type === 'credit') {
          return 'text-[#34A770]'
        }
        if (type === 'debit') {
          return 'text-[#E31A1A]'
        }
        if (type === 'cashback') {
          return 'text-[#CC9212]'
        }
        return ''
      }
    },
    resetFilter() {
      return () => {
        this.startDate = moment().format('YYYY-MM-DD')
        this.endDate = moment().format('YYYY-MM-DD')
        this.transactionType = ''
        this.getMutation(this.$route.params.id)
        this.offset = 0
      }
    },
  },
  watch: {
    cards: {
      handler(e) {
        if (e.balance === null) {
          this.getBalanceMonit()
        }
      },
      deep: true,
    },
  },
  created() {
    window.onscroll = () => {
      if (
        window.innerHeight + window.scrollY
          >= document.getElementById('scroll').offsetHeight
        && !this.loading.mutation
      ) {
        this.getNextDataMutation()
      }
    }
  },
  mounted() {
    this.getCards()
    this.getMutation()
  },
  methods: {
    onSubmit(value) {
      if (this.stateForOpenPIN === 'active-inactive') {
        this.activeInactiveCard(value)
      } else if (this.stateForOpenPIN === 'reveal') {
        this.revealCard(value)
      } else if (this.stateForOpenPIN === 'change-card-name') {
        this.onChangeCardName(value)
      } else if (this.stateForOpenPIN === 'change-label') {
        this.onChangeCardLabel(value)
      } else if (this.stateForOpenPIN === 'withdrawal') {
        this.onWithdrawal(value)
      } else if (this.stateForOpenPIN === 'transfer') {
        this.onTransfer(value)
      } else if (this.stateForOpenPIN === 'topup') {
        this.onTopup(value)
      }
    },
    getAvatarData(value) {
      return getAcronym(value)
    },
    async getBalance() {
      const url = `/v1/dashboard/partner/balanceSummary?partner_id=${this.idPartner}`
      await komshipAxiosIns
        .get(url)
        .then(res => {
          const { data: { balance } } = res.data
          this.balanceData = balance
        })
        .catch(() => {
          this.$toast_error({ message: 'Gagal memuat data balance, silahkan coba lagi' })
        })
    },

    async getBalanceMonit() {
      const url = '/komcards/api/v1/card/balance-cards'
      try {
        const res = await newAxiosIns.request({
          method: 'post',
          data: {
            card_ids: [parseInt(this.cardId, 10)],
          },
          url,
        })

        this.cards.balance = res.data.data[0].balance
        return
      } catch {
        this.$toast_error({ message: 'Gagal load data get balance' })
      }
    },
    async activeInactiveCard(pin) {
      const form = new FormData()
      form.append('card_id', this.cardId)
      form.append('pin', pin)

      this.loading.status = true
      const activeUrl = `/komcards/api/v1/card/${this.cardId}/activated`
      const inactiveUrl = `/komcards/api/v1/card/${this.cardId}/deactivated`
      // eslint-disable-next-line no-shadow
      const url = this.cards.status !== 'active' ? activeUrl : inactiveUrl

      await newAxiosIns
        .request({
          url,
          method: 'put',
          data: form,
        })
        .then(() => {
          const activeMessage = 'Kartu Berhasil di Aktifkan'
          const inactiveMessage = 'Kartu Berhasil di Non-Aktifkan'

          const message = this.cards.status !== 'active' ? activeMessage : inactiveMessage

          this.loading.activeInactive = false
          this.$bvModal.hide('modal-verify-pin')
          this.$toast_success({ message })
          this.getCards()
          this.loading.status = false
        })
        .catch(err => {
          const { message } = err.response.data
          if (message === 'card has been freeze') {
            this.$toast_error({ message: 'Kartu terkena autofreeze oleh sistem. Silahkan hubungi CS kami.' })
          } else {
            this.$toast_error({ message })
          }
          this.loading.status = false
        })
    },
    handleCopyCardNumber() {
      navigator.clipboard.writeText(this.reveal.cardNumber)
      this.$toast_success({ message: 'Nomor kartu berhasil disalin' })
    },
    handleTransfer() {
      this.stateForOpenPIN = 'transfer'
      this.checkBalance()
      this.checkVerifyPIN('transfer')
      this.$root.$emit('bv::hide::popover', 'action')
    },
    handleTopup() {
      if (this.cards.level === 'bronze') return
      this.stateForOpenPIN = 'topup'
      this.getBalance()
      this.checkVerifyPIN('topup')
      this.$root.$emit('bv::hide::popover', 'action')
    },
    async getCards() {
      this.loading.card = true
      const url = `komcards/api/v1/card/${this.cardId}/detail`
      await newAxiosIns
        .get(url)
        .then(res => {
          const { data } = res.data

          // handle change data from BE
          this.cards.labels = data.labels
          this.cards.name = data.name
          this.cards.id = parseInt(this.cardId, 10)
          this.cards.status = data.status
          this.cards.card_network = data.info.card_network
          this.cards.card_number = data.info.card_number
          this.cards.exp_date = data.info.exp_date
          this.cards.cvv = data.info.cvv
          this.cards.balance = null
          this.cards.hold_balance = data.balance.hold_balance
          this.cards.voucher_balance = data.balance.voucher_balance
          this.cards.daily_spending = data.spending.daily_spending
          this.cards.daily_spending_limit = data.spending.daily_spending_limit
          this.cards.team_members = data.team_members
          this.cards.level = data.level

          this.loading.card = false
        })
        .catch(() => {
          this.loading.card = false
          this.$toast_error({
            message: 'Gagal memuat data kartu, silahkan coba lagi',
          })
        })
    },
    async getMutation() {
      this.loading.mutation = true
      this.offset = 0
      const params = {
        start_date: this.startDate,
        end_date: this.endDate,
        transaction_type: this.transactionType,
        offset: this.offset,
        limit: this.limit,
        card_id: this.cardId,
      }
      const url = '/komcards/api/v1/card/mutation'
      await newAxiosIns
        .get(url, { params })
        .then(res => {
          const { data } = res.data
          this.listMutation = data
          this.loading.mutation = false

          this.offset = data.length
          if (data.length < this.limit) {
            this.lastData = true
          } else {
            this.lastData = false
          }
        })
        .catch(() => {
          this.loading.mutation = false
          this.$toast_error({
            message: 'Gagal memuat data mutasi, silahkan coba lagi',
          })
        })
    },
    getNextDataMutation() {
      if (!this.lastData) {
        this.loading.mutation = true
        const params = {
          start_date: this.startDate,
          end_date: this.endDate,
          transaction_type: this.transactionType,
          offset: this.offset,
          limit: this.limit,
          card_id: this.cardId,
        }
        const url = '/komcards/api/v1/card/mutation'
        newAxiosIns
          .get(url, { params })
          .then(res => {
            const { data } = res.data
            this.loading.mutation = false
            this.listMutation.push(...data)
            this.offset += data.length
            if (data.length < this.limit) {
              this.lastData = true
            }
          })
          .catch(() => {
            this.loading.mutation = false
            this.$toast_error({
              message: 'Gagal memuat data mutasi, silahkan coba lagi',
            })
          })
      }
    },
    async revealCard(pin) {
      this.loading.reveal = true
      const form = new FormData()
      form.append('pin', pin)
      form.append('card_id', this.cardId)
      const url = `/komcards/api/v1/card/${this.cardId}/show`
      await newAxiosIns
        .request({ url, data: form, method: 'post' })
        .then(result => {
          const { data } = result.data
          this.loading.reveal = false
          this.reveal = data
          this.showReveal = true
          this.$bvModal.hide('modal-verify-pin')
          this.decryptedCard(data.encrypted_data)
          this.countDownTimer()
        })
        .catch(() => {
          this.loading.reveal = false
        })
    },
    async checkBalance() {
      this.loading.informationBalance = true

      const url = `/komcards/api/v1/card/${this.cardId}/info-balance`

      await newAxiosIns
        .get(url)
        .then(res => {
          const { data } = res.data
          this.loading.informationBalance = false
          const balanceDetail = { ...data, balance: data.real_balance }
          this.balanceDetail = balanceDetail
        })
        .catch(() => {
          this.loading.informationBalance = false
          this.$toast_error({
            message: 'Gagal memuat data balance, silahkan coba lagi',
          })
        })
    },
    async checkVerifyPIN(param) {
      await newAxiosIns.get('/auth/api/v1/user/secured/verify-pin/attempt-left')
        .then(response => {
          const { data } = response.data
          if (data.attempt_left === 0) {
            this.$bvModal.show('max-chance-PIN')
          } else if (param === 'change-card-name') {
            this.$bvModal.show('modal-change-card-name')
          } else if (['active-inactive', 'reveal'].includes(param)) {
            this.$bvModal.show('modal-verify-pin')
          } else if (param === 'withdrawal') {
            this.$bvModal.show('modal-withdrawal')
          } else if (param === 'transfer') {
            this.$bvModal.show('modal-transfer')
          } else if (param === 'topup') {
            this.$bvModal.show('modal-topup')
          } else if (param === 'change-label') {
            this.$bvModal.show('modal-change-label')
          }
        }).catch(() => {
          this.$toast_error({ message: 'Gagal cek PIN, silahkan refresh page' })
        })
    },
    async checkKyc(param) {
      this.loading.file = true
      this.stateForOpenPIN = param
      const url = '/auth/api/v1/partner/request-verification-ktp/latest-history'
      await newAxiosIns
        .get(url)
        .then(res => {
          const { data } = res.data
          this.loading.file = false
          this.kyc = data
          if (data.status === 'approved') {
            return this.checkVerifyPIN(param)
            // return param === 'reveal'
            //   ? this.checkVerifyPIN(param)
            //   : this.$bvModal.show('modal-withdrawal')
          }
          if (
            this.role === 'TALENT GLOBAL'
            && ['requested', 'rejected', 'not requested'].includes(data.status)
          ) {
            return this.$toast_error({
              title: 'KTP Partner Belum Diverifikasi',
              message:
                'Kamu belum dapat menggunakan fitur ini karena partner kamu belum melakukan verifikasi KTP',
            })
          }
          if (data.status === 'requested') {
            return this.$toast_error({
              title: 'Fitur Ini Belum Bisa Digunakan',
              message:
                'Kamu sudah mengajukan Verifikasi KTP agar dapat menggunakan fitur ini. Silahkan tunggu konfirmasi lebih lanjut selama 1x24 jam',
            })
          }
          if (data.status === 'not requested') {
            return this.$bvModal.show(this.idModal)
          }
          return this.$router.push('/verification-ktp')
        })
        .catch(() => {
          this.loading.file = false
        })
    },
    async onChangeCardName(pin) {
      const url = `/komcards/api/v1/card/${this.cards.id}/update`
      const body = {
        name: this.card_name,
        pin,
      }
      await newAxiosIns.put(url, body)
        .then(() => {
          this.card_name = ''
          this.$toast_success({ message: 'Nama kartu berhasil diubah' })
          this.$bvModal.hide('modal-verify-pin')
          this.$bvModal.hide('modal-change-card-name')
          this.getCards()
        })
        .catch(err => {
          const { message } = err.response.data.meta
          if (message === 'card has been freeze') {
            this.$toast_error({ message: 'Kartu terkena autofreeze oleh sistem. Silahkan hubungi CS kami.' })
            return
          }
          this.$toast_error({ message: 'Terjadi kesalahan sementara. Mohon coba lagi dalam beberapa saat' })
        })
        .finally(() => {
          this.$refs.moda.onReset()
        })
    },
    async onChangeCardLabel(pin) {
      const url = `/komcards/api/v1/card/${this.cards.id}/labels`
      const body = {
        labels: this.card_label,
        pin,
      }
      await newAxiosIns.put(url, body)
        .then(() => {
          this.card_label = ''
          this.$toast_success({ message: 'Nama label berhasil diubah' })
          this.$bvModal.hide('modal-verify-pin')
          this.$bvModal.hide('modal-change-label')
          this.getCards()
        })
        .catch(err => {
          const { message } = err.response.data.meta
          if (message === 'card has been freeze') {
            this.$toast_error({ message: 'Kartu terkena autofreeze oleh sistem. Silahkan hubungi CS kami.' })
            return
          }
          this.$toast_error({ message: 'Terjadi kesalahan sementara. Mohon coba lagi dalam beberapa saat' })
        })
        .finally(() => {
          this.$refs.modalChangeLabel.onReset()
        })
    },
    async onWithdrawal(pin) {
      const url = '/komcards/api/v1/card/refund'
      const payload = {
        card_id: this.cards.id,
        balance: Number(this.nominal_withdrawal.replace(/[^0-9]/g, '')),
        pin,
      }
      await newAxiosIns.post(url, payload)
        .then(() => {
          this.nominal_withdrawal = ''
          this.$toast_success({ message: 'Saldo berhasil di tarik' })
          this.$bvModal.hide('modal-verify-pin')
          this.$bvModal.hide('modal-withdrawal')
          this.getCards()
          this.getMutation()
          this.$refs.modalWithdrawal.onReset()
        })
        .catch(err => {
          const { message } = err.response.data
          if (message === 'insufficient kompay balance') {
            this.$toast_error({ message: 'Saldo anda tidak mencukupi.' })
          } else if (message === 'card has been freeze') {
            this.$toast_error({ message: 'Kartu terkena autofreeze oleh sistem. Silahkan hubungi CS kami.' })
          } else {
            this.$toast_error({ message: 'Terjadi kesalahan ketika topup, mohon hubungi team cs kami untuk lebih lanjut' })
          }
        })
        .finally(() => {
          this.$refs.modalWithdrawal.onReset()
        })
    },
    async onTransfer(pin) {
      const url = `/komcards/api/v1/card/${this.cardId}/transfer-balance`
      const payload = {
        pin,
        transfer_to: this.cardTransferId,
        amount: Number(this.transferAmount.replace(/[Rp. ]/g, '')),
      }
      await newAxiosIns.post(url, payload)
        .then(() => {
          this.$toast_success({ message: 'Saldo berhasil ditransfer' })
          this.transferAmount = null
          this.cardTransferId = null
          this.getCards()
          this.getMutation()
        })
        .catch(err => {
          const { message } = err.response.data.meta
          if (message === 'pending transaction found, cannot proceed') {
            this.$toast_error({ message: 'Transaksi sedang diproses. Mohon tunggu beberapa saat' })
          } else if (message === 'card has been freeze') {
            this.$toast_error({ message: 'Kartu terkena autofreeze oleh sistem. Silahkan hubungi CS kami.' })
          } else if (message === 'insufficient kompay balance') {
            this.$toast_error({ message: 'Transaksi tidak dapat diproses. Silakan periksa saldo Kompay Anda.' })
          } else {
            this.$toast_error({ message: 'Terjadi kesalahan sementara. Mohon coba lagi dalam beberapa saat' })
          }
        })
        .finally(() => {
          this.$refs.modalTransfer.onReset()
        })
    },
    async onTopup(pin) {
      const payload = {
        card_id: this.cards.id,
        balance: Number(this.topupAmount.replace(/[^0-9]/g, '')),
        pin,
      }
      const url = '/komcards/api/v1/card/topup'
      await newAxiosIns.post(url, payload)
        .then(() => {
          const message = 'Top up berhasil di lakukan'
          this.$toast_success({ message })
          this.$bvModal.hide('modal-verify-pin')
          this.$bvModal.hide('modal-topup')
          this.getCards()
          this.getMutation()
          this.$refs.modalTopup.onReset()
        })
        .catch(err => {
          const { message } = err.response.data
          if (message === 'insufficient kompay balance') {
            this.$toast_error({ message: 'Saldo anda tidak mencukupi' })
          } else if (message === 'card has been freeze') {
            this.$toast_error({ message: 'Kartu terkena autofreeze oleh sistem. Silahkan hubungi CS kami.' })
          } else if (message === 'pending transaction found, cannot proceed') {
            this.$toast_error({ message: 'Maaf, top up belum dapat dilakukan karena masih terdapat transaksi sebelumnya yang belum selesai. Silakan coba beberapa saat lagi.' })
          } else {
            this.$toast_error({ message: 'Terjadi kesalahan ketika topup, mohon hubungi team cs kami untuk lebih lanjut' })
          }
        })
        .finally(() => {
          this.$refs.modalTopup.onReset()
        })
    },
    countDownTimer() {
      const timer = setInterval(() => {
        if (this.timerCount > 0) {
          this.timerCount -= 1
        } else {
          this.showReveal = false
          this.timerCount = 60
          clearInterval(timer)
        }
      }, 1000)
    },
    copyCardNumber() {
      if (this.showReveal) {
        navigator.clipboard.writeText(this.reveal.cardNumber)
        this.$toast_success({ message: 'Nomor kartu berhasil disalin' })
      }
    },
    routeVerification() {
      this.$router.push('/verification-ktp')
    },
    decryptedCard(encrypted) {
      const decode = atob(encrypted)
      const numberArray = decode.split('%%').map(Number)
      const resultArray = numberArray.map((value, index) => {
        const result = value / (3 * (index + 1))
        if (index === 2) {
          return result.toString()
        }
        if ([0, 1, 3, 4, 5].includes(index)) {
          return result < 1000
            ? result.toString().padStart(4, '0')
            : result.toFixed(0)
        }
        return result.toFixed(0)
      })
      const cardNumber = resultArray
        .slice(0, 2)
        .concat(resultArray.slice(4, 6))
        .join('')
        .match(/.{1,4}/g)
        .join(' ')
      const cvv = resultArray[2].padStart(3, 0)
      const expDate = `${resultArray[3].substring(
        0,
        2,
      )}/${resultArray[3].substring(2)}`

      this.reveal.cardNumber = cardNumber
      this.reveal.cvv = cvv
      this.reveal.expDate = expDate
    },
    handleDailyLimit() {
      if (this.cards.level === 'bronze') return
      this.$root.$emit('bv::hide::popover', 'action')

      // Show loading overlay
      this.loading.dailyLimit = true

      // Call the API to check if upgrade is allowed
      const url = `/komcards/api/v1/card/${this.cardId}/check-daily-limit`

      newAxiosIns
        .get(url)
        .then(response => {
          const { data } = response.data

          if (data.is_allow_upgrade) {
            this.$bvModal.show('modal-daily-limit')
          } else {
            const getType = data.notes.replaceAll(' ', '_').toLowerCase()

            if (getType.includes('daily_spending_card')) {
              this.dailyLimitErrorTitle = 'Limit harianmu saat ini belum dapat ditingkatkan'
              this.dailyLimitErrorMessage = 'Yuk tingkatkan spending atau hubungi CS'
            } else if (getType.includes('frozen')) {
              this.dailyLimitErrorTitle = 'Kartu kamu sedang dalam kondisi auto freeze oleh sistem '
              this.dailyLimitErrorMessage = 'Freeze diterapkan untuk memastikan keamanan transaksi kamu terjamin. Silahkan hubungi CS untuk bantuan lebih lanjut'
            }
            this.$bvModal.show('modal-daily-limit-error')
          }
        })
        .catch(error => {
          this.$toast_error({
            message: 'Gagal memeriksa limit harian kartu. Silahkan coba lagi!.',
          })
        })
        .finally(() => {
          this.loading.dailyLimit = false
        })
    },
    onClose() {
      this.$bvModal.hide('modal-verify-pin')
      if (this.stateForOpenPIN === 'change-card-name') {
        this.$bvModal.show('modal-change-card-name')
        this.label = null
      } else if (this.stateForOpenPIN === 'change-label') {
        this.$bvModal.show('modal-change-label')
        this.card_label = null
      } else if (this.stateForOpenPIN === 'withdrawal') {
        this.$bvModal.show('modal-withdrawal')
        this.nominal_withdrawal = null
      } else if (this.stateForOpenPIN === 'transfer') {
        this.$bvModal.show('modal-transfer')
        this.transferAmount = null
        this.cardTransferId = null
      } else if (this.stateForOpenPIN === 'topup') {
        this.$bvModal.show('modal-topup')
        this.topupAmount = null
      }
    },
    updateCardName(value) {
      this.card_name = value
    },
    updateLabel(value) {
      this.card_label = value
    },
    updateNominalWithdrawal(value) {
      this.nominal_withdrawal = value
    },
    updatePayloadTransfer(value) {
      this.transferAmount = value.amount
      this.cardTransferId = value.cardTransferId
    },
    updateNominalTopup(value) {
      this.topupAmount = value
    },
  },
}
</script>

<style scoped>
#action {
  border: none !important;
}

.wrapper_card {
  display: grid;
  gap: 20px;
}

@media screen and (min-width: 991px) {
  .wrapper_card {
    grid-template-columns: 4fr 8fr;
  }
}

@media screen and (min-width: 1000px) {
  .wrapper_card {
    grid-template-columns: 4fr 8fr;
  }
}

.active-reveal {
  background-color: white !important;
  color: #626262 !important;
  font-weight: 500 !important;
  opacity: 1 !important;
}
</style>
